import React from "react";
import PropTypes from "prop-types";
import Dropdown from "react-bootstrap/Dropdown";
import BsBadge from "react-bootstrap/Badge";
import styled from "styled-components";

import NotificationIcon from "../../../Icons/Notification";

/**
 * props definition
 */
const propTypes = {
  theme: PropTypes.oneOf(["light", "dark"])
};

const defaultProps = {
  theme: "dark"
};

const Notification = ({ theme }) => {
  return (
    <Wrapper>
      <Dropdown.Toggle className="px-0 border-0 bg-transparent" as="button">
        <span>
          <NotificationIcon
            variant="outline"
            {...(theme === "light" && { color: "#fff" })}
          />
        </span>
        <Badge
          pill
          className="d-flex align-items-center justify-content-center"
          {...{ theme }}
        >
          23
        </Badge>
      </Dropdown.Toggle>
      <Dropdown.Menu />
    </Wrapper>
  );
};

/**
 * styles
 */
const Badge = styled(BsBadge)`
  top: -1px;
  left: 0.75rem;
  padding: 0 3px;
  min-width: 22px;
  min-height: 22px;
  position: absolute;
  opacity: 1 !important;

  ${({ theme }) => {
    if (theme === "light") {
      return `
        color: var(--bs-primary);
        background-color: #fff !important;
        border: solid 2px var(--bs-primary);
        `;
    }

    if (theme === "dark") {
      return `
        color: #fff;
        border: solid 2px #fff;
        background-color: var(--bs-primary) !important;
        `;
    }
  }};
`;

const Wrapper = styled(Dropdown)`
  .dropdown-toggle {
    width: 2rem;
    height: 2rem;
    display: flex;
    cursor: pointer;
    position: relative;
    align-items: flex-end;
    justify-content: center;
  }
`;

Notification.propTypes = propTypes;
Notification.defaultProps = defaultProps;

export default Notification;
